<template>
  <div v-if="visivel" class="modal is-active">

    <div class="modal-background" @click="fechar"></div>

    <div class="modal-card">
      <header class="modal-card-head has-background-primary">
        <p class="modal-card-title">
          Associe a Nota ao Balanço Patrimonial
        </p>
        <button class="delete" aria-label="close" @click="fechar"></button>
      </header>

      <section class="modal-card-body">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>Linha do Balanço</th>
              <th class="has-text-centered">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(nebp, index) in notasExplicativasBP" :key="nebp.id">
              <td>{{ nebp.balanco_patrimonial_versao_config.descricao }}</td>
              <td class="has-text-centered">
                <button class="button is-small is-info is-outlined" @click="editarNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-edit"></i>
                  </span>
                </button>
                <button class="button is-small is-danger is-outlined" @click="excluirNota(index)" :disabled="habilitaLancamento">
                  <span class="icon is-small">
                    <i class="fas fa-trash"></i>
                  </span>
                </button>
              </td>
            </tr>

            <tr v-if="notasExplicativasBP.length === 0">
              <td colspan="3" class="has-text-centered has-text-grey">
                Nenhuma fórmula cadastrada para esta linha.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="has-text-right mt-3">
          <button class="button is-success" @click="novaNota" :disabled="habilitaLancamento">
            Cadastrar
          </button>
        </div>

        <br/>

        <div class="card" v-if="habilitaLancamento">
          <header class="card-header">
            <p class="card-header-title">Edição</p>            
          </header>
        
          <div class="card-content">
            <form class="is-fullwidth">
              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Balanço Patrimonial</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="cmbBalanco" class="is-fullwidth" :disabled="notaExplicativaBP.id != null"  @change="selectBP()">
                          <option v-for="bp in balancos" :key="bp.balanco_patrimonial_versao.id" :value="bp.balanco_patrimonial_versao.id">
                            {{ bp.balanco_patrimonial_versao.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal is-fullwidth">
                <div class="field-label is-normal">
                  <label class="label">Linha</label>
                </div>
                <div class="field-body">
                  <div class="field is-fullwidth">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="notaExplicativaBP.balanco_patrimonial_versao_config" class="is-fullwidth" :disabled="cmbBalanco == null ">
                          <option v-for="item in itensBalanco" :key="item.id" :value="item">
                            {{ item.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <footer class="card-footer">
            <button class="button is-success" @click="save">Salvar</button>
            <button class="button" v-on:click="habilitaLancamento = false">Cancelar</button>
          </footer>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: "NotaExplicativaBP",
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    linha: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notaExplicativaBP: {
          id: null,
          balanco_patrimonial_versao_config: null,
          nota_explicativa_nota: null,
      },
      notasExplicativasBP: [],
      balancos: [],
      itensBalanco: [],
      cmbBalanco: null,
      habilitaLancamento: false
    };
  },
  watch: {
    linha(novaLinha) {
      if (novaLinha && novaLinha.id) {
        this.carregarNotas();
      }
    },
    visivel(novoValor) {
      if (novoValor && this.linha?.id) {
        this.carregarNotas();
      }
    }
  },
  methods: {
    clearFields: function() {
      this.notaExplicativaBP = {
        id: null,
        nota_explicativa_nota: parseInt(this.linha.id),
        balanco_patrimonial_versao_config: null,
        index: null
      }
    },

    save: function() {
      var data

      if (this.notaExplicativaBP.balanco_patrimonial_versao_config == null) {
           alert('Linha do balanço patrimonial não selecionada!')
           return
       }

      data = {id: this.notaExplicativaBP.id,
          balanco_patrimonial_versao_config: this.notaExplicativaBP.balanco_patrimonial_versao_config.id,
          nota_explicativa_notas: this.linha.id
      }

      if (this.notaExplicativaBP.id == null) {
          http.post('/notaExplicativa/adicionarNotasBP', data).then(response =>{
              if (response.data.id != undefined && response.data.id != '') {
                  this.notaExplicativaBP.id = response.data.id
                  this.notasExplicativasBP.push(this.notaExplicativaBP)
                  this.clearFields()
              } else {
                  alert(response.request.responseText)
              }
          }).catch(e => {
              alert(e.response.data);
              return
          })
      } 
      else {
          http.put('/notaExplicativa/editarNotasBP/'+this.notaExplicativaBP.id, data).then(response =>{
              this.notasExplicativasBP[this.notaExplicativaBP.index].id = response.data.id
              this.notasExplicativasBP[this.notaExplicativaBP.index].balanco_patrimonial_versao_config = this.notaExplicativaBP.balanco_patrimonial_versao_config
          }).catch(e => {
              alert(e.response.data);
              return
          })
      }                    

    },

    async carregarNotas() {
      if (!this.linha || !this.linha.id) return;

      try {
        const response = await http.get(`/notaExplicativa/listarNotasBP/`, {
          params: { idNotaExplicativa: parseInt(this.linha.id) }
        });
        this.notasExplicativasBP = response.data.results;
      } catch (error) {
        console.error("Erro ao carregar as associações com o balanço patrimonial:", error);
        alert("Não foi possível carregar as associações com o balanço patrimonial. Verifique a linha selecionada ou tente novamente.");
      }
    },

    async novaNota() {
      this.habilitaLancamento = true
      this.clearFields()
    },

    async editarNota(index) {
      this.habilitaLancamento = true
      this.notaExplicativaBP.id = this.notasExplicativasBP[index].id
      this.notaExplicativaBP.nota_explicativa_nota = parseInt(this.linha.id)
      this.notaExplicativaBP.balanco_patrimonial_versao_config = this.notasExplicativasBP[index].balanco_patrimonial_versao_config
      this.cmbBalanco = this.notasExplicativasBP[index].balanco_patrimonial_versao_config.balanco_patrimonial_versao.id
      this.selectBP()
      this.notaExplicativaBP.index = index
    },

    async excluirNota(index) {
      if (window.confirm('Confirma exclusão?')) {
        http.delete('/notaExplicativa/excluirNotasBP/'+this.notasExplicativasBP[index].id).then(response =>{
            this.notasExplicativasBP.splice(index, 1)
            if (response.status == 204) {
                alert('Registro excluído!')
            }
        }).catch(e => {
            console.log(e);
        })
      }
    },

    fechar() {
      this.$emit("fechar");
    },

    selectBP: function() {
        http.get('balancoPatrimonialVersaoConfig/listar/', {params: {
            idBalancoPatrimonialVersao: this.cmbBalanco
        }}).then(response => {
            this.itensBalanco = response.data.results
            if (this.itensBalanco.length == 0) {
                alert('Não há itens do balanço patrimonial selecionado cadastrados!')
            }
        })
    },

  },

  mounted() {
    http.get('balancoPatrimonialVersao/listarBalancos/', {
        params: { idVersaoPlanoContas: this.linha.nota_explicativa_periodo.perfil.versao_plano_contas },
      }).then(response => {
        this.balancos = response.data.results;
      })
      .catch(error => {
        console.error("Erro ao carregar balanços patrimoniais:", error);
      });

      this.carregarNotas()
  }
};
</script>
